exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#div_home [data-v-59d27b2c]{box-sizing:border-box}#div_home[data-v-59d27b2c]{margin:15px auto;padding-left:10px;border-left:2px solid #eee;border-style:none none none solid}.li_paper[data-v-59d27b2c]{text-decoration:none;color:#b00;font-size:13.5px;font-style:normal}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-59d27b2c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home.vue
// module id = 118
// module chunks = 0